import React from 'react';
import { createRoot } from 'react-dom/client';

import './index.css';
import { App } from './app.js';
import { getMsalInstance } from './auth/msal.js';
import { LOCAL_MODE } from './config/local-mode.js';

const container = document.getElementById('root');
if (!container) throw new Error('Root container missing');

function mount(): void {
  createRoot(container!).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

if (LOCAL_MODE) {
  // Phase 14: skip MSAL bootstrap entirely. The local HTTP server is
  // localhost-only with no auth.
  mount();
} else {
  const msal = getMsalInstance();
  void msal
    .initialize()
    .then(() => msal.handleRedirectPromise())
    .catch((err: unknown) => {
      console.error('msal-redirect-handle-failed', err);
    })
    .finally(mount);
}
